// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { BackOrderModel } from "@guestsupply/App/Services/BackorderManagementService";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";

interface Parameter {
    backorder?: BackOrderModel | CartLineModel;
    modalIsOpen: boolean;
}

type HandlerType = Handler<Parameter>;

export const DispatchCompleteSetShipFromAltDCModalIsOpen: HandlerType = props => {
    props.dispatch({
        type: "xBackorder/CompleteSetIsOpen",
        isOpen: props.parameter.modalIsOpen,
        backorder: props.parameter.backorder,
    } as any);
};

export const chain = [DispatchCompleteSetShipFromAltDCModalIsOpen];

const setShipFromAltDCModalIsOpen = createHandlerChainRunner(chain, "SetShipFromAltDCModalIsOpen");
export default setShipFromAltDCModalIsOpen;
